import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { OTHER_SERVICES, BUILD_LIST } from "../data";

export default function OtherServices() {
  return (
    <main data-testid="other-services-page" className="pt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 lg:py-14">
        <span className="text-xs tracking-[0.25em] uppercase font-semibold text-[#A95C42]">
          Beyond the trail
        </span>
        <h1 className="font-serif-display text-5xl sm:text-6xl tracking-tight font-medium text-[#1E352F] mt-2">
          General Contracting
        </h1>
        <p className="text-base text-[#4A5D54] mt-3 max-w-2xl leading-relaxed">
          We do far more than trails. With 20 years of experience and the right
          machines, we handle the building, dirt work, and finishing that bring a
          Montana property together.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 mt-8">
          {OTHER_SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`other-service-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="rounded-sm border border-[#D1CFC7] bg-[#FFFFFF] overflow-hidden flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[4/3] group">
                <img
                  src={s.url}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="font-serif-display text-2xl text-[#1E352F]">
                  {s.title}
                </h3>
                <p className="text-sm text-[#4A5D54] mt-2 leading-relaxed">
                  {s.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>

        {/* Build list */}
        <div className="mt-10 rounded-sm border border-[#D1CFC7] bg-[#FFFFFF] p-8 lg:p-10">
          <h2 className="font-serif-display text-3xl text-[#1E352F]">
            If you can dream it, we can build it.
          </h2>
          <p className="text-base text-[#4A5D54] mt-2 max-w-2xl leading-relaxed">
            From custom matched sheds and pole barns to shops and full custom homes,
            we can build just about anything you want on your property.
          </p>
          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 max-w-xl">
            {BUILD_LIST.map((item) => (
              <li key={item} className="flex items-center gap-3 text-[#2D4A3E]">
                <Check className="h-4 w-4 text-[#A95C42] shrink-0" strokeWidth={2.5} />
                <span className="text-base">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6 rounded-sm border border-[#D1CFC7] bg-[#EAE7E0] p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <p className="font-serif-display text-2xl text-[#1E352F] max-w-xl">
            Got a project in mind? No job too big or too small.
          </p>
          <Link
            to="/quote"
            data-testid="other-services-quote-button"
            className="inline-flex items-center gap-2 bg-[#2D4A3E] text-[#F8F7F4] px-6 py-3 rounded-sm font-medium hover:bg-[#1E352F] transition-colors duration-300 whitespace-nowrap"
          >
            Request a Quote <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </main>
  );
}
